export enum ErrorCode {
  MissingCountryCode = 422,
  Forbidden = 403,
}

export enum AuthErrorCode {
  SessionExpired = "AUP001",
  EmptyGroup = "AUP002",
}
